module.exports = __webpack_public_path__ + "img/btn_kuangxuan_ov.84c32831.png";